export default __webpack_public_path__ + "static/media/vegetarian.1296191a.png";